import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CustomerServicesService } from 'src/app/customer-service/customer-services.service';
import { LookupService } from 'src/app/shared/services/lookup.service';
@Injectable({
  providedIn: 'root',
})
export class CompanyResolver {
  constructor(private customerServicesService: CustomerServicesService, private lookupService: LookupService) {
    this.lookupService.getLocationLookups();
  }
  resolve(route: ActivatedRouteSnapshot) {
    const id = route.paramMap.get('id') ?? '';
    this.customerServicesService.setAllActiveEmployeesCount(id);
    return this.customerServicesService.GetAdminCompany(id);
  }
}
